import React, { useCallback, useEffect, useMemo, useState } from "react";
import * as RB from "react-bootstrap";
import DataTable from "react-data-table-component";
import FilterComponent from "../FilterComponent";
import Swal from "sweetalert2";
import EditIcon from "@mui/icons-material/Edit";
import { Delete } from "@mui/icons-material";
import * as utils from "../../Utils/comman";
import { useSelector } from "react-redux";
import {
  AddCircle,
  ArrowDown,
  DocumentDownload,
  Edit,
  Edit2,
  ProfileAdd,
  Trash,
} from "iconsax-react";
import moment from "moment/moment";
import { Link } from "react-router-dom";
import * as XLSX from "xlsx";
import CustomPagination from "../../Utils/CustomPagination";

function List(props) {
  const [materialLIst, setMaterialLIst] = useState([]);
  const [page, setPage] = useState(1);
  const countPerPage = 10;
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const primaryMenuRes = useSelector(
    (state) => state?.primaryMenu?.primaryMenu?.permissions,
  );
  const [categoryList, setCategoryList] = useState([]);
  const [units, setUnits] = useState([]);

  const [category, setCategory] = useState("");
  const [createdBy, setCreatedBy] = useState("");
  const [itemName, setItemName] = useState("");
  const [itemCode, setItemCode] = useState("");
  const [brandName, setBrandName] = useState("");
  const [unit, setUnit] = useState("");
  const [filter, setFilter] = useState(false);

  const handleAddClick = (e) => {
    const propdata = {
      mode: "add",
    };
    props.onChange(propdata);
  };

  const columns = [
    {
      name: "Sr.No",
      selector: (row, index) => index + 1,
      width: "68px",
    },
    {
      name: (
        <div>
          Date Created <br />
        </div>
      ),
      selector: (row) => moment(row.createdAt).format("DD-MM-YYYY"),
    },
    {
      name: (
        <div>
          Created By <br />
        </div>
      ),
      selector: (row) => row.created_name,
    },
    {
      name: "Category",
      selector: (row) => row.category_name,
    },
    {
      name: (
        <div>
          Item Name <br />
        </div>
      ),
      selector: (row) => (
        <div
          data-toggle="tooltip"
          data-placement="top"
          title={row.product_name}
        >
          {row.product_name}
        </div>
      ),
    },
    {
      name: (
        <div>
          Item Code <br />
        </div>
      ),
      selector: (row) => row.product_code,
    },
    {
      name: "Brand",
      selector: (row) => row.brand_name,
    },
    {
      name: "Unit",
      selector: (row) => row.name,
      width: "68px",
    },
    {
      name: (
        <div>
          Lead Time(IN days) <br />
        </div>
      ),
      selector: (row) => row.lead_time,
      width: "83px",
    },
    {
      name: (
        <div>
          HSN code <br />
        </div>
      ),
      selector: (row) => row.hsn_code,
    },
    {
      name: (
        <div>
          CAS No. <br />
        </div>
      ),
      selector: (row) => row.cas_no,
    },

    // {
    //   name: (
    //     <div>
    //       Stock Alert <br />
    //     </div>
    //   ),
    //   selector: (row) => row.email,
    // },
    {
      name: "Status",
      selector: (row) => (row.status == "1" ? "Active" : "inActive"),
    },
    {
      name: "Action",
      center: true,
      cell: (row) => (
        <>
          {utils.hasPermission(
            primaryMenuRes,
            "Raw Material",
            "raw_material.edit",
          ) && (
            <RB.Button
              className="btn-flat"
              title="Edit"
              onClick={handelEdit(row)}
            >
              <Edit2 />
            </RB.Button>
          )}
          {utils.hasPermission(
            primaryMenuRes,
            "Raw Material",
            "raw_material.delete",
          ) && (
            <RB.Button
              className="btn-flat ms-1"
              title="Delete"
              onClick={showDelete(row)}
            >
              <Trash />
            </RB.Button>
          )}
        </>
      ),
    },
  ];

  const handleAssignPermission = useCallback((row) => async () => {
    const propdata = {
      mode: "permission",
      rowData: row,
    };
    props.onChange(propdata);
  });

  useEffect(() => {
    getMateriallist();
  }, [page]);

  const getMateriallist = useCallback(() => {
    utils
      .callAPI(
        "get",
        `/rawmaterial/list?page=${page}&per_page=${countPerPage}&created_by=${createdBy}&category=${category}&item_name=${itemName}&item_code=${itemCode}&brand_name=${brandName}&unit=${unit}`,
      )
      .then((res) => {
        setFilter(false);
        setMaterialLIst(res || []);
      })
      .catch(() => {
        setMaterialLIst([]);
        setFilter(false);
      });
  }, [page, createdBy, category, itemName, itemCode, brandName, unit]);

  useEffect(() => {
    getCat();
    getUnits();
  }, []);

  const getUnits = () => {
    utils
      .callAPI("get", `/unit/list`)
      .then((res) => {
        if (typeof res !== "undefined") {
          const filteredUnits = res?.result?.filter(
            (category) => category.status === "1",
          );
          setUnits(filteredUnits);
        } else {
          setUnits([]);
        }
      })
      .catch((err) => {
        setUnits([]);
      });
  };

  const getCat = () => {
    utils
      .callAPI("get", `/rawmaterial/category/list`)
      .then((res) => {
        if (typeof res !== "undefined") {
          const filteredCategories = res?.result?.filter(
            (category) => category.status === "1",
          );
          setCategoryList(filteredCategories);
        } else {
          setCategoryList([]);
        }
      })
      .catch((err) => {
        setCategoryList([]);
      });
  };

  const handleCat = (event) => {
    setCategory(event.target.value);
  };

  const handelEdit = useCallback((row) => async () => {
    const propdata = {
      mode: "edit",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const handleStatusChange = useCallback((row) => async () => {
    console.log(row);
    const newStatus = row.isActive === "1" ? "0" : "1";

    var bodyFormData = new FormData();
    bodyFormData.append("id", row.id);
    bodyFormData.append("firstName", row.firstName);
    bodyFormData.append("middleName", row.middleName);
    bodyFormData.append("lastName", row.lastName);
    bodyFormData.append("mobileNo", row.mobileNo);
    bodyFormData.append("email", row.email);
    bodyFormData.append("isActive", newStatus);
    bodyFormData.append("roleId", row.roleId);
    utils
      .callAPI("post", `/users/users-edit`, bodyFormData)
      .then((res) => {
        if (typeof res !== "undefined") {
          getMateriallist();
        }
      })
      .catch((err) => {});
  });

  const showDelete = useCallback((row) => async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      showDenyButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        utils
          .callAPI("get", `/rawmaterial/delete?id=${row.id}`, "")
          .then((res) => {
            if (typeof res !== "undefined") {
              getMateriallist();
            }
          })
          .catch((err) => {});
      }
    });
  });

  const subHeaderComponent = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      <>
        <div className="me-2">
          {/* <RB.FloatingLabel
            controlId="Category"
            name="category"
            // label="Category"
          > */}

          {/* </RB.FloatingLabel> */}
        </div>
        <FilterComponent
          onFilter={(e) => setFilterText(e.target.value)}
          onClear={handleClear}
          filterText={filterText}
        />
      </>
    );
  }, [filterText, resetPaginationToggle]);

  useEffect(() => {
    if (filter) {
      getMateriallist();
    }
  }, [filter]);

  const handleSearch = () => {
    if (page === 1) {
      getMateriallist();
    } else {
      setPage(1);
    }
  };

  const handleReset = () => {
    setCreatedBy("");
    setCategory("");
    setItemCode("");
    setItemName("");
    setBrandName("");
    setUnit("");
    setFilter(true);
  };

  const handleDownload = () => {
    utils
      .callAPI(
        "get",
        `/rawmaterial/export-material?created_by=${createdBy}&category=${category}&item_name=${itemName}&item_code=${itemCode}&brand_name=${brandName}&unit=${unit}`,
      )
      .then((res) => {
        if (typeof res !== "undefined") {
          console.log(res);
          generateCSV(res);
        } else {
        }
      })
      .catch((err) => {});
  };

  function generateCSV(filteredData) {
    const ws = XLSX.utils.json_to_sheet(filteredData, {
      header: Object.keys(filteredData[0]),
      skipHeader: true,
    });

    const wb = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(wb, ws, "Raw Material");

    const csvOutput = XLSX.utils.sheet_to_csv(ws);

    const blob = new Blob([csvOutput], { type: "text/csv;charset=utf-8;" });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "raw_material_list.csv";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  return (
    <div className="section-body">
      <RB.Card className="card shadow ">
        <div className="floating-btns-holder-artisan">
          <a
            href
            className="btn btn-primary btn-circle me-2"
            variant="primary"
            onClick={() => handleDownload()}
          >
            <DocumentDownload />
          </a>
          {utils.hasPermission(
            primaryMenuRes,
            "Raw Material",
            "raw_material.create",
          ) && (
            <a
              href
              className="btn btn-dark btn-circle"
              variant="dark"
              onClick={handleAddClick}
            >
              <AddCircle />
            </a>
          )}
        </div>

        <RB.Card.Header>
          <h4></h4>
          <div className="card-header-action"></div>
        </RB.Card.Header>
        <RB.Card.Body>
          <RB.Row className="mb-2 g-2">
            <RB.Col className="col-md col-12">
              <RB.Form.Control
                type="text"
                placeholder="Created By"
                value={createdBy}
                onChange={(e) => setCreatedBy(e.target.value)}
              />
            </RB.Col>
            <RB.Col className="col-md col-12">
              <RB.Form.Select value={category} onChange={handleCat} required>
                <option value="">Select Category...</option>
                {categoryList?.map((status) => (
                  <option key={status.id} value={status.id}>
                    {status.category_name}
                  </option>
                ))}
              </RB.Form.Select>
            </RB.Col>
            <RB.Col className="col-md col-12">
              <RB.Form.Control
                type="text"
                placeholder="Item Name"
                value={itemName}
                onChange={(e) => setItemName(e.target.value)}
              />
            </RB.Col>
            <RB.Col className="col-md col-12">
              <RB.Form.Control
                type="text"
                placeholder="Item Code"
                value={itemCode}
                onChange={(e) => setItemCode(e.target.value)}
              />
            </RB.Col>
            <RB.Col className="col-md col-12">
              <RB.Form.Control
                type="text"
                placeholder="Brand Name"
                value={brandName}
                onChange={(e) => setBrandName(e.target.value)}
              />
            </RB.Col>
            <RB.Col className="col-md col-12">
              <RB.Form.Select
                value={unit}
                onChange={(e) => setUnit(e.target.value)}
                required
              >
                <option value="">Select Unit...</option>
                {units?.map((status) => (
                  <option key={status.id} value={status.id}>
                    {status.name}
                  </option>
                ))}
              </RB.Form.Select>
            </RB.Col>{" "}
            <div className="col-md col-12">
              <RB.Button
                className=" btn-md"
                variant="primary"
                onClick={handleSearch}
                disabled={
                  !createdBy &&
                  !category &&
                  !itemName &&
                  !itemCode &&
                  !brandName &&
                  !unit
                }
              >
                Find
              </RB.Button>
              <Link
                className="ms-2 btn-underline"
                // variant="secondary"
                onClick={handleReset}
              >
                Reset
              </Link>
            </div>
          </RB.Row>
          {utils.hasPermission(
            primaryMenuRes,
            "Raw Material",
            "raw_material.view",
          ) && (
            <DataTable
              columns={columns}
              data={materialLIst.result}
              highlightOnHover
              responsive
              pagination
              paginationServer
              paginationTotalRows={materialLIst.total}
              paginationPerPage={countPerPage}
              paginationComponentOptions={{
                noRowsPerPage: true,
              }}
              paginationComponent={() => (
                <CustomPagination
                  currentPage={page}
                  totalRows={materialLIst.total}
                  rowsPerPage={countPerPage}
                  onPageChange={handlePageChange}
                />
              )}
              striped
              onChangePage={(page) => setPage(page)}
              persistTableHead
              customStyles={{
                head: {
                  style: {
                    fontSize: "0.875rem", // Adjust the font size as needed
                    fontWeight: "bold", // Adjust the font weight as needed
                  },
                },
              }}
              // subHeader
              // subHeaderComponent={subHeaderComponent}
            />
          )}
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default List;
